import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useState } from 'react';
import { FieldValues, useForm, Controller } from 'react-hook-form';
import * as z from 'zod';
import { LoadingIcon } from '../../../assets/Icon';
import useAPI from '../../../hooks/useAPI';
import Modal from '../../common/modal/Modal';
import Button from '../../ui/Button';
import Input from '../../ui/Input';
import TransactionSuccessModal from '../transaction-success-dialog';
import styles from './style.module.scss';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import { NumericFormat } from 'react-number-format';

type AddCashModalProps = {
  open: boolean;
  onClose: () => void;
};

const schema = z.object({
  amount: z
    .string()
    ?.nonempty('Amount is required')
    .refine(val => !isNaN(Number(val)), { message: 'Amount must be a number' }),
});

const AddCashModal = ({ onClose, open }: AddCashModalProps) => {
  const [cashAdded, setCashAdded] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    control,
  } = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    mode: 'all',
  });

  const { refetch, isLoading, data } = useAPI({
    url: `/auth/add/user/cash`,
    method: 'POST',
    onSuccess: data => {
      onClose();
      setCashAdded(true);
      reset();
      toast.success(data.result.message);
    },
    onError: error => {
      toast.error(error?.response?.data?.message || 'An error occurred');
    },
    autoFetch: false,
  });

  const onSubmit = (data: FieldValues) => {
    const payload = {
      amount: data?.amount,
      address: '',
    };
    refetch(payload);
  };

  return (
    <>
      <TransactionSuccessModal
        open={cashAdded}
        title="Cash Amount Added Successfully in your Wallet!"
        isCloseIconVisible={true}
        onClose={() => setCashAdded(false)}
      />
      <Modal
        open={open}
        title="Add Cash"
        onClose={() => {
          onClose();
          reset();
        }}
        isCloseIconVisible={!isLoading}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="" className={styles.label}>
              Enter Amount <span className="text-danger">*</span>
            </Form.Label>
            <Controller
              name="amount"
              control={control}
              render={({ field }) => (
                <NumericFormat
                  thousandSeparator
                  decimalScale={0}
                  allowNegative={false}
                  customInput={Input}
                  onValueChange={value => field.onChange(value.value)}
                />
              )}
            />
          </Form.Group>
          {/* <div className={styles.information}>
            Amount <span>{watch('amount') || 0}</span> will be added to your
            wallet from your linked account No. 501XXXXX2527
          </div> */}
          <div className={styles.actions}>
            <Button
              variant="outline"
              type="button"
              onClick={() => {
                onClose();
                reset();
              }}
            >
              Cancel
            </Button>
            <Button disabled={isLoading} variant="dark" type="submit">
              {isLoading && <LoadingIcon />}
              Request
            </Button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default AddCashModal;
